import abi from './Transactions.json'


export const contractABI = abi.abi

export const contractAddress = '0xd6761B33D283068dC8f37D409dEdE4c1de78A224'